import { render, staticRenderFns } from "./OrderViewActionsSpecAwaitingCustomerValidation.vue?vue&type=template&id=61ab90fc&"
import script from "./OrderViewActionsSpecAwaitingCustomerValidation.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecAwaitingCustomerValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports